import { inject, Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private messageService = inject(MessageService);

  success(message: string, title = 'Success'): void {
    this.messageService.add({
      severity: 'success',
      summary: title,
      detail: message,
      life: 3000,
    });
  }

  private lastErrorMsg = '';
  private lastErrorTime = 0;

  error(message: string, title = 'Error'): void {
    const now = Date.now();
    if (this.lastErrorTime && (now - this.lastErrorTime) < 500) {
      if (this.lastErrorMsg.includes(message) || message.includes(this.lastErrorMsg)) {
        // Prevent duplicate toasts for the same error
        return;
      }
    }
    this.lastErrorMsg = message;
    this.lastErrorTime = now;

    this.messageService.add({
      severity: 'error',
      summary: title,
      detail: message,
      life: 5000,
    });
  }

  warn(message: string, title = 'Warning'): void {
    this.messageService.add({
      severity: 'warn',
      summary: title,
      detail: message,
      life: 4000,
    });
  }

  info(message: string, title = 'Info'): void {
    this.messageService.add({
      severity: 'info',
      summary: title,
      detail: message,
      life: 3000,
    });
  }
}
